import { createFileRoute } from '@tanstack/react-router';
import { AiChatPage } from '@/features/ai-chat/pages/ai-chat-page';

export const Route = createFileRoute('/_app/ai-chat')({ component: AiChatPage });
